import Card from './ant';

export default Card;
